import Settings from 'src/Settings';
import BaseDescriptor from './redemptionDetail-default';
import AramarkDescriptor from './redemptionDetail-aramark';
import {createTypeDescriber} from 'src/utils/DescriptorUtils';

const typeDescriber = createTypeDescriber(BaseDescriptor);

typeDescriber.aramark = AramarkDescriptor;

export function getDescriber() {
  return typeDescriber[Settings.buildType];
}
